/* eslint-disable */
export default {
  noActiveCalls: 'Aucun appel actif',
  noCalls: 'Aucun résultat.',
  currentCall: 'Appel en cours',
  ringCall: 'Sonnerie en cours',
  onHoldCall: 'Appel en attente',
  historyCalls: 'Appels émis dans le passé',
  otherDeviceCall: 'Appels en cours sur mes autres terminaux',
  searchPlaceholder: 'Recherche…',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
